module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAJCAYAAADtj3ZXAAAAAXNSR0IArs4c6QAAATVJREFUKBVjZACCmTNncqWnp38DsQmBefPmif7+/TsQqG4l0/Tp0wP/////acaMGROANCM+zbNnz5b59evX0X///s0EqgtlYmFheQTU9AeI84EumIHLgDlz5sj/+fPnIFBeFajxPBsb2xqm1NTUs0xMTH5Age9AiTSgAfOANBOyC4BOVQI69SBQTAmIT/Px8TknJiZ+gDsTqMkRqGkzEHMzMjIuFRISig8LC/sL9A7Ipn1AcRmg+HEeHh6PmJiYTyDD4ZpBHKCfbP/+/bsVqJAXqHA1MzNzC5C/A8iXBPIPAQ30Bhr4BaQWBFA0gwSABlhANfADNfwFamQGCu8Des0XPUYwNIMMADrVBKhpF5ApCMQ7hYWFA4E2fgfJIQOsmkEKgKGrAowSOxkZmaVeXl4/kTXB2ADfcZYCzPJNjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-opened.png
// module id = 348
// module chunks = 0 5 6 9 10